import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Styled from 'app/features/couponCampaign/landing/components/Perks/Perks.styled';
import S from 'app/features/couponCampaign/landing/components/HeroBlock.styled';
import AdFreeAnime from 'app/features/couponCampaign/landing/components/Perks/AdFreeAnime';
import OneHourAfterJapanBroadcast from 'app/features/couponCampaign/landing/components/Perks/OneHourAfterJapanBroadcast';
import OfflineViewing from 'app/features/couponCampaign/landing/components/Perks/OfflineViewing';
import StreamOnDevices from 'app/features/couponCampaign/landing/components/Perks/StreamOnDevices';
import Heading from 'app/components/layout/Heading.styled';

const UI = ({ titleId }) => (
  <Styled.Perks>
    <Heading size="s" as={Styled.Title}>
      <FormattedMessage id={titleId} />
    </Heading>
    <S.PerksHolder>
      <OneHourAfterJapanBroadcast />
      <AdFreeAnime />
      <OfflineViewing />
      <StreamOnDevices />
    </S.PerksHolder>
  </Styled.Perks>
);

UI.displayName = 'Perks';

UI.propTypes = {
  titleId: PropTypes.string.isRequired,
};

export { UI };

export default UI;
